import React, { useState, useEffect, useRef } from "react";
import "./GirukambakkamDental.css";
const GirukambakkamDental = () => {
  const [activeTab, setActiveTab] = useState("all");
  const [isScrolled, setIsScrolled] = useState(false);
  const [isAnimating, setIsAnimating] = useState({});
  const [activeTestimonial, setActiveTestimonial] = useState(0);
  const [activeGalleryItem, setActiveGalleryItem] = useState(0);
  const [expandedCategory, setExpandedCategory] = useState(null);

  // Ref for horizontal scroll container
  const testimonialScrollRef = useRef(null);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 100);

      // Check if elements are in viewport for animations
      document.querySelectorAll(".animate-on-scroll").forEach((element) => {
        const rect = element.getBoundingClientRect();
        const isInViewport =
          rect.top <=
            (window.innerHeight || document.documentElement.clientHeight) *
              0.8 && rect.bottom >= 0;

        if (isInViewport) {
          setIsAnimating((prev) => ({ ...prev, [element.id]: true }));
        }
      });
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  // Auto-scroll gallery functionality
  useEffect(() => {
    const galleryInterval = setInterval(() => {
      setActiveGalleryItem((prevIndex) =>
        prevIndex === galleryItems.length - 1 ? 0 : prevIndex + 1
      );
    }, 4000); // Change image every 4 seconds

    // Cleanup interval on component unmount
    return () => clearInterval(galleryInterval);
  }, []);

  // Auto-scroll testimonials functionality (for carousel, not for horizontal scroll)
  useEffect(() => {
    const testimonialInterval = setInterval(() => {
      setActiveTestimonial((prevIndex) =>
        prevIndex === testimonials.length - 1 ? 0 : prevIndex + 1
      );
    }, 5000); // Change testimonial every 5 seconds

    // Cleanup interval on component unmount
    return () => clearInterval(testimonialInterval);
  }, []);

  // Handler for category clicks
  const handleCategoryClick = (categoryId) => {
    setExpandedCategory(categoryId);
  };
  // Handler for tab clicks
  const handleTabClick = (tabId) => {
    setActiveTab(tabId);
    setExpandedCategory(null); // Reset expanded category when changing tabs
  };

  // Handler for testimonial navigation
  const goToTestimonial = (index) => {
    setActiveTestimonial(index);
  };

  // Before & After gallery - with 10 items
  const galleryItems = [
    {
      id: 1,
      treatment: "Complete Smile Makeover",
      before: "/images/dental/before-1.jpg",
      after: "/images/dental/after-1.jpg",
    },
    {
      id: 2,
      treatment: "Teeth Whitening",
      before: "/images/dental/before-2.jpg",
      after: "/images/dental/after-2.jpg",
    },
    {
      id: 3,
      treatment: "Dental Implants",
      before: "/images/dental/before-3.jpg",
      after: "/images/dental/after-3.jpg",
    },
    {
      id: 4,
      treatment: "Invisalign Treatment",
      before: "/images/dental/before-4.jpg",
      after: "/images/dental/after-4.jpg",
    },
    {
      id: 5,
      treatment: "Porcelain Veneers",
      before: "/images/dental/before-5.jpg",
      after: "/images/dental/after-5.jpg",
    },
    {
      id: 6,
      treatment: "Dental Crowns",
      before: "/images/dental/before-6.jpg",
      after: "/images/dental/after-6.jpg",
    },
    {
      id: 7,
      treatment: "Root Canal Therapy",
      before: "/images/dental/before-7.jpg",
      after: "/images/dental/after-7.jpg",
    },
    {
      id: 8,
      treatment: "Gum Contouring",
      before: "/images/dental/before-8.jpg",
      after: "/images/dental/after-8.jpg",
    },
    {
      id: 9,
      treatment: "Dental Bridges",
      before: "/images/dental/before-9.jpg",
      after: "/images/dental/after-9.jpg",
    },
    {
      id: 10,
      treatment: "Composite Bonding",
      before: "/images/dental/before-10.jpg",
      after: "/images/dental/after-10.jpg",
    },
  ];

  // Advanced treatments with categories
  const treatments = [
    {
      id: 1,
      title: "General Dentistry",
      description:
        "Preview your smile transformation with our 3D imaging technology before treatment begins.",
      image:
        "https://images.unsplash.com/photo-1597765221336-1f65bb4c4fee?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MXxzZWFyY2h8Nnx8ZGVudGFsJTIwbGFifGVufDB8fHx8MTc0MjUwMDI2N3ww&auto=format&fit=crop&w=600&q=60",
      category: "cosmetic",
      icon: "https://img.icons8.com/fluency/96/teeth.png",
    },
    {
      id: 2,
      title: "Endodontics",
      description:
        "Custom clear aligners that straighten teeth discreetly without the need for metal braces.",
      image:
        "https://images.unsplash.com/photo-1598256989800-fe5f95da9787?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MXxzZWFyY2h8Nnx8ZGVudGlzdHxlbnwwfHx8fDE3NDI0NDc1MjR8MA&auto=format&fit=crop&w=600&q=60",
      category: "orthodontic",
      icon: "https://img.icons8.com/fluency/96/retainer.png",
    },
    {
      id: 3,
      title: "Prosthodontics",
      description:
        "Precision treatments with minimal discomfort using state-of-the-art dental lasers.",
      image:
        "https://images.unsplash.com/photo-1616391182219-e080b4d1043a?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MXxzZWFyY2h8Nnx8ZGVudGlzdCUyMGNsaW5pY3xlbnwwfHx8fDE3NDI1NDM3NDN8MA&auto=format&fit=crop&w=600&q=60",
      category: "advanced",
      icon: "https://img.icons8.com/fluency/96/laser-beam.png",
    },
    {
      id: 4,
      title: "Periodontics",
      description:
        "Ultra-thin porcelain shells that transform teeth with imperfections into a flawless smile.",
      image:
        "https://images.unsplash.com/photo-1609840114035-3c981b782dfe?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MXxzZWFyY2h8Nnx8ZGVudGFsJTIwc21pbGV8ZW58MHx8fHwxNzQyNTAwMTE4fDA&auto=format&fit=crop&w=600&q=60",
      category: "cosmetic",
      icon: "https://img.icons8.com/fluency/96/tooth-cleaning.png",
    },
    {
      id: 5,
      title: "OMFS",
      description:
        "Custom-designed titanium implants created with precision 3D printing technology.",
      image:
        "https://images.unsplash.com/photo-1468493858157-0da44aaf1d13?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MXxzZWFyY2h8Nnx8ZGVudGFsJTIwaW1wbGFudHxlbnwwfHx8fDE3NDI1NDk0NjB8MA&auto=format&fit=crop&w=600&q=60",
      category: "restorative",
      icon: "https://img.icons8.com/fluency/96/tooth-drill.png",
    },
    {
      id: 6,
      title: "Pediatric Dentistry",
      description:
        "Early detection of dental issues using artificial intelligence and machine learning.",
      image:
        "https://images.unsplash.com/photo-1588776814601-a454a8e3a940?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MXxzZWFyY2h8Nnx8ZGVudGFsJTIwdHJlYXRtZW50fGVufDB8fHx8MTc0MjQ4MTAwNHww&auto=format&fit=crop&w=600&q=60",
      category: "advanced",
      icon: "https://img.icons8.com/fluency/96/artificial-intelligence.png",
    },
    {
      id: 7,
      title: "Orthodontics",
      description:
        "Laser-assisted gum contouring to create a more balanced and aesthetic smile line.",
      image:
        "https://images.unsplash.com/photo-1600170311833-c2cf5280ce49?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MXxzZWFyY2h8Nnx8ZGVudGFsJTIwc3VyZ2VyeXxlbnwwfHx8fDE3NDI1Mjk5OTd8MA&auto=format&fit=crop&w=600&q=60",
      category: "cosmetic",
      icon: "https://img.icons8.com/fluency/96/gums.png",
    },
    {
      id: 8,
      title: "Implantology",
      description:
        "Conservative treatments that preserve natural tooth structure while restoring function.",
      image:
        "https://images.unsplash.com/photo-1606811856475-5e6fcdc6e509?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MXxzZWFyY2h8Nnx8ZGVudGFsJTIwY2xpbmljfGVufDB8fHx8MTc0MjU0MDAwMHww&auto=format&fit=crop&w=600&q=60",
      category: "restorative",
      icon: "https://img.icons8.com/fluency/96/tooth.png",
    },
    {
      id: 9,
      title: "Sleep Apnea Therapy",
      description:
        "Custom oral appliances to treat sleep apnea and improve quality of sleep and health.",
      image:
        "https://images.unsplash.com/photo-1588776814546-1ffcf47267a5?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MXxzZWFyY2h8Nnx8ZGVudGFsJTIwb2ZmaWNlfGVufDB8fHx8MTc0MjQ4MTc5OXww&auto=format&fit=crop&w=600&q=60",
      category: "specialized",
      icon: "https://img.icons8.com/fluency/96/sleeping.png",
    },
  ];

  const filteredTreatments =
    activeTab === "all"
      ? treatments
      : treatments.filter((treatment) => treatment.category === activeTab);

  // Main treatment categories
  const categories = [
    {
      id: "general",
      name: "General Dentistry",
      icon: "https://img.icons8.com/fluency/96/tooth.png",
      image:
        "https://images.unsplash.com/photo-1588776814546-1ffcf47267a5?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=60",
      description: "Comprehensive dental care for patients of all ages",
      treatments: [
        {
          id: "scaling",
          title: "Scaling",
          description:
            "Professional cleaning to remove plaque and tartar buildup",
          image:
            "https://images.unsplash.com/photo-1588776814546-1ffcf47267a5?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=60",
          icon: "https://img.icons8.com/fluency/96/tooth-cleaning.png",
        },
        {
          id: "gic-filling",
          title: "GIC Filling",
          description:
            "Glass Ionomer Cement fillings for restoring damaged teeth",
          image:
            "https://images.unsplash.com/photo-1606811971618-4486d14f3f99?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=60",
          icon: "https://img.icons8.com/fluency/96/dental-filling.png",
        },
        {
          id: "composite-filling",
          title: "Composite Filling",
          description:
            "Tooth-colored fillings that blend seamlessly with your natural teeth",
          image:
            "https://images.unsplash.com/photo-1609840114035-3c981b782dfe?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=60",
          icon: "https://img.icons8.com/fluency/96/dental-filling.png",
        },
      ],
    },
    {
      id: "endodontics",
      name: "Endodontics",
      icon: "https://img.icons8.com/fluency/96/dental-root.png",
      image:
        "https://images.unsplash.com/photo-1606811841689-23dfddce3e95?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=60",
      description:
        "Specialized treatments for the dental pulp and root canal system",
      treatments: [
        {
          id: "rct",
          title: "Root Canal Treatment (RCT)",
          description:
            "Procedure to remove infected pulp and save the natural tooth",
          image:
            "https://images.unsplash.com/photo-1606811841689-23dfddce3e95?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=60",
          icon: "https://img.icons8.com/fluency/96/dental-root.png",
        },
        {
          id: "laser-rct",
          title: "Laser RCT",
          description:
            "Advanced root canal treatment using laser technology for precision",
          image:
            "https://images.unsplash.com/photo-1616391182219-e080b4d1043a?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=60",
          icon: "https://img.icons8.com/fluency/96/laser-beam.png",
        },
        {
          id: "re-rct",
          title: "Re-RCT",
          description:
            "Retreatment of previously treated root canals that have failed",
          image:
            "https://images.unsplash.com/photo-1600170311833-c2cf5280ce49?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=60",
          icon: "https://img.icons8.com/fluency/96/dental-root.png",
        },
      ],
    },
    {
      id: "prostho",
      name: "Prosthodontics",
      icon: "https://img.icons8.com/fluency/96/dentures.png",
      image:
        "https://images.unsplash.com/photo-1606811856475-5e6fcdc6e509?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=60",
      description:
        "Dental prostheses to replace missing teeth and restore function",
      treatments: [
        {
          id: "crowns",
          title: "Crowns",
          description:
            "Custom-made caps that cover damaged teeth to restore shape and function",
          image:
            "https://images.unsplash.com/photo-1606811856475-5e6fcdc6e509?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=60",
          icon: "https://img.icons8.com/fluency/96/tooth-crown.png",
        },
        {
          id: "bridges",
          title: "Bridges",
          description:
            "Fixed dental prostheses to replace one or more missing teeth",
          image:
            "https://images.unsplash.com/photo-1598256989800-fe5f95da9787?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=60",
          icon: "https://img.icons8.com/fluency/96/dental-bridge.png",
        },
        {
          id: "veneers",
          title: "Veneers",
          description:
            "Thin porcelain shells bonded to front teeth to improve appearance",
          image:
            "https://images.unsplash.com/photo-1609840114035-3c981b782dfe?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=60",
          icon: "https://img.icons8.com/fluency/96/dentist.png",
        },
      ],
    },
    {
      id: "perio",
      name: "Periodontics",
      icon: "https://img.icons8.com/fluency/96/gums.png",
      image:
        "https://images.unsplash.com/photo-1588776814546-1ffcf47267a5?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=60",
      description:
        "Treatment of gum diseases and conditions affecting the supporting structures",
      treatments: [
        {
          id: "root-planing",
          title: "Root Planing",
          description:
            "Deep cleaning below the gumline to treat periodontal disease",
          image:
            "https://images.unsplash.com/photo-1588776814546-1ffcf47267a5?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=60",
          icon: "https://img.icons8.com/fluency/96/gums.png",
        },
        {
          id: "flap-surgery",
          title: "Flap Surgery",
          description:
            "Surgical procedure to reduce pocket depths and restore gum health",
          image:
            "https://images.unsplash.com/photo-1600170311833-c2cf5280ce49?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=60",
          icon: "https://img.icons8.com/fluency/96/surgery.png",
        },
      ],
    },
    {
      id: "omfs",
      name: "Oral & Maxillofacial Surgery",
      icon: "https://img.icons8.com/fluency/96/tooth-extraction.png",
      image:
        "https://images.unsplash.com/photo-1600170311833-c2cf5280ce49?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=60",
      description:
        "Surgical procedures involving the mouth, jaw, and facial structures",
      treatments: [
        {
          id: "extraction",
          title: "Extraction",
          description:
            "Removal of teeth that cannot be saved or are causing problems",
          image:
            "https://images.unsplash.com/photo-1600170311833-c2cf5280ce49?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=60",
          icon: "https://img.icons8.com/fluency/96/tooth-extraction.png",
        },
        {
          id: "impaction",
          title: "Impaction",
          description:
            "Surgical removal of impacted teeth that cannot erupt normally",
          image:
            "https://images.unsplash.com/photo-1468493858157-0da44aaf1d13?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=60",
          icon: "https://img.icons8.com/fluency/96/wisdom-tooth.png",
        },
      ],
    },
    {
      id: "pedo",
      name: "Pediatric Dentistry",
      icon: "https://img.icons8.com/fluency/96/baby-smile.png",
      image:
        "https://images.unsplash.com/photo-1588776814546-1ffcf47267a5?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=60",
      description:
        "Specialized dental care for children from infancy through adolescence",
      treatments: [
        {
          id: "pulpectomy",
          title: "Pulpectomy",
          description:
            "Root canal treatment for primary teeth to save them from extraction",
          image:
            "https://images.unsplash.com/photo-1588776814546-1ffcf47267a5?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=60",
          icon: "https://img.icons8.com/fluency/96/baby-tooth.png",
        },
        {
          id: "pedo-extraction",
          title: "Extraction",
          description: "Gentle removal of primary teeth when necessary",
          image:
            "https://images.unsplash.com/photo-1600170311833-c2cf5280ce49?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=60",
          icon: "https://img.icons8.com/fluency/96/tooth-extraction.png",
        },
      ],
    },
    {
      id: "ortho",
      name: "Orthodontics",
      icon: "https://img.icons8.com/fluency/96/braces.png",
      image:
        "https://images.unsplash.com/photo-1598256989800-fe5f95da9787?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=60",
      description:
        "Correction of teeth and jaw alignment for improved function and aesthetics",
      treatments: [
        {
          id: "braces",
          title: "Braces",
          description:
            "Traditional metal braces to straighten teeth and correct bite issues",
          image:
            "https://images.unsplash.com/photo-1598256989800-fe5f95da9787?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=60",
          icon: "https://img.icons8.com/fluency/96/braces.png",
        },
        {
          id: "aligners",
          title: "Clear Aligners",
          description: "Invisible aligners for discreet teeth straightening",
          image:
            "https://images.unsplash.com/photo-1609840114035-3c981b782dfe?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=60",
          icon: "https://img.icons8.com/fluency/96/retainer.png",
        },
      ],
    },
    {
      id: "implants",
      name: "Dental Implants",
      icon: "https://img.icons8.com/fluency/96/tooth-implant.png",
      image:
        "https://images.unsplash.com/photo-1468493858157-0da44aaf1d13?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=60",
      description:
        "Permanent tooth replacement solutions that look and function like natural teeth",
      treatments: [
        {
          id: "single-implant",
          title: "Single Tooth Implant",
          description:
            "Titanium post surgically placed to replace a single missing tooth",
          image:
            "https://images.unsplash.com/photo-1468493858157-0da44aaf1d13?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=60",
          icon: "https://img.icons8.com/fluency/96/tooth-implant.png",
        },
        {
          id: "full-arch",
          title: "Full Arch Implants",
          description:
            "Complete replacement of all teeth in an arch with implant-supported prosthesis",
          image:
            "https://images.unsplash.com/photo-1606811856475-5e6fcdc6e509?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=60",
          icon: "https://img.icons8.com/fluency/96/dentures.png",
        },
      ],
    },
  ];

  // Technology features
  const technologies = [
    {
      id: "tech1",
      title: "3D Imaging & Printing",
      description:
        "Create precise dental restorations and surgical guides with cutting-edge 3D technology",
      icon: "https://img.icons8.com/fluency/96/3d-printer.png",
    },
    {
      id: "tech2",
      title: "AI-Assisted Diagnosis",
      description:
        "Early detection of dental conditions with artificial intelligence algorithms",
      icon: "https://img.icons8.com/fluency/96/artificial-intelligence.png",
    },
    {
      id: "tech3",
      title: "VR Pain Management",
      description:
        "Virtual reality distraction therapy to reduce anxiety and discomfort during procedures",
      icon: "https://img.icons8.com/fluency/96/virtual-reality.png",
    },
    {
      id: "tech4",
      title: "Digital Smile Design",
      description:
        "Visualize your smile transformation before treatment begins",
      icon: "https://img.icons8.com/fluency/96/design.png",
    },
  ];

  const teamMembers = [
    {
      id: 1,
      name: "Dr. Helena Cura",
      role: "Founder & Cosmetic Dentist",
      bio: "Internationally recognized for her expertise in aesthetic dentistry and smile design.",
      image:
        "https://images.unsplash.com/photo-1622253692010-333f2da6031d?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80",
    },
    {
      id: 2,
      name: "Dr. Michael Chen",
      role: "Implantologist",
      bio: "Specialist in advanced implant procedures and 3D-guided implant surgery.",
      image:
        "https://images.unsplash.com/photo-1612349317150-e413f6a5b16d?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80",
    },
    {
      id: 3,
      name: "Dr. Sofia Rodriguez",
      role: "Orthodontist",
      bio: "Expert in invisible aligners and minimally invasive orthodontic treatments.",
      image:
        "https://images.unsplash.com/photo-1594824476967-48c8b964273f?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80",
    },
  ];

  // Testimonials - Updated with more testimonials
  // Testimonials - Updated with more testimonials
// ...existing code...
  // Testimonials - Unique for Gerugambakkam
  const testimonials = [
    {
      id: 1,
      name: "Ramesh Chandran",
      treatment: "Dental Implants",
      quote:
        "The Gerugambakkam clinic restored my confidence with their precise dental implants. The doctors explained every step and the results are fantastic.",
      image:
        "https://images.unsplash.com/photo-1519125323398-675f0ddb6308?ixlib=rb-4.0.3&auto=format&fit=crop&w=100&q=80",
      rating: 5,
    },
    {
      id: 2,
      name: "Sowmya Rajan",
      treatment: "Root Canal Therapy",
      quote:
        "I was nervous about my root canal, but the team at H-CURA Gerugambakkam made it painless and comfortable. The clinic is very hygienic and modern.",
      image:
        "https://images.unsplash.com/photo-1529626455594-4ff0802cfb7e?ixlib=rb-4.0.3&auto=format&fit=crop&w=100&q=80",
      rating: 5,
    },
    {
      id: 3,
      name: "Vikram Prabhu",
      treatment: "Braces & Orthodontics",
      quote:
        "My braces journey at Gerugambakkam was smooth and the orthodontist was very patient. My smile is now perfectly aligned!",
      image:
        "https://images.unsplash.com/photo-1517841905240-472988babdf9?ixlib=rb-4.0.3&auto=format&fit=crop&w=100&q=80",
      rating: 5,
    },
    {
      id: 4,
      name: "Anjali Menon",
      treatment: "Smile Makeover",
      quote:
        "I always wanted a beautiful smile. The smile makeover at H-CURA Gerugambakkam gave me natural-looking results and a big boost in confidence.",
      image:
        "https://images.unsplash.com/photo-1544005313-94ddf0286df2?ixlib=rb-4.0.3&auto=format&fit=crop&w=100&q=80",
      rating: 5,
    },
    {
      id: 5,
      name: "Sathya Narayanan",
      treatment: "Wisdom Tooth Extraction",
      quote:
        "My wisdom tooth removal at Gerugambakkam was quick and pain-free. The follow-up care was excellent and the staff were very supportive.",
      image:
        "https://images.unsplash.com/photo-1515378791036-0648a3ef77b2?ixlib=rb-4.0.3&auto=format&fit=crop&w=100&q=80",
      rating: 5,
    },
    {
      id: 6,
      name: "Divya Shankar",
      treatment: "Teeth Whitening",
      quote:
        "I got my teeth whitened at H-CURA Gerugambakkam and the results were amazing. The clinic is clean and the staff are very friendly.",
      image:
        "https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?ixlib=rb-4.0.3&auto=format&fit=crop&w=100&q=80",
      rating: 5,
    },
    {
      id: 7,
      name: "Rahul Srinivas",
      treatment: "Pediatric Dentistry",
      quote:
        "My daughter actually enjoys her dental visits now! The pediatric dentist at Gerugambakkam is patient and makes every appointment fun.",
      image:
        "https://images.unsplash.com/photo-1508214751196-bcfd4ca60f91?ixlib=rb-4.0.3&auto=format&fit=crop&w=100&q=80",
      rating: 5,
    },
    {
      id: 8,
      name: "Lakshmi Priya",
      treatment: "Gum Treatment",
      quote:
        "I had gum issues for years. The gum treatment at Gerugambakkam clinic was effective and my gums are much healthier now.",
      image:
        "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?ixlib=rb-4.0.3&auto=format&fit=crop&w=100&q=80",
      rating: 5,
    },
    {
      id: 9,
      name: "Suresh Kumar",
      treatment: "Dental Crowns",
      quote:
        "Needed a crown for my broken tooth. The process at Gerugambakkam was quick and the crown looks just like my natural tooth.",
      image:
        "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?ixlib=rb-4.0.3&auto=format&fit=crop&w=100&q=80",
      rating: 5,
    },
    {
      id: 10,
      name: "Anitha Ramesh",
      treatment: "General Dentistry",
      quote:
        "Routine checkups at H-CURA Gerugambakkam are always thorough. The doctors take time to explain everything and make me feel at ease.",
      image:
        "https://images.unsplash.com/photo-1580489944761-15a19d654956?ixlib=rb-4.0.3&auto=format&fit=crop&w=100&q=80",
      rating: 5,
    },
    {
      id: 11,
      name: "Karthik Venkatesan",
      treatment: "Cosmetic Fillings",
      quote:
        "I had cosmetic fillings done at Gerugambakkam and they blend perfectly with my teeth. The attention to detail is impressive.",
      image:
        "https://images.unsplash.com/photo-1524253482453-3fed8d2fe12b?ixlib=rb-4.0.3&auto=format&fit=crop&w=100&q=80",
      rating: 5,
    },
  ];

  // Auto-scroll for horizontal testimonial cards
  useEffect(() => {
    const container = testimonialScrollRef.current;
    if (!container) return;

    let autoScroll;
    const cardWidth = 370; // 350px card + 2rem gap approx
    const scrollStep = cardWidth;

    function startAutoScroll() {
      autoScroll = setInterval(() => {
        if (!container) return;
        // If at end, scroll back to start
        if (
          container.scrollLeft + container.offsetWidth >=
          container.scrollWidth - 5
        ) {
          container.scrollTo({ left: 0, behavior: "smooth" });
        } else {
          container.scrollBy({ left: scrollStep, behavior: "smooth" });
        }
      }, 3000);
    }
    startAutoScroll();

    // Pause on hover
    const pause = () => clearInterval(autoScroll);
    const resume = () => startAutoScroll();

    container.addEventListener("mouseenter", pause);
    container.addEventListener("mouseleave", resume);

    return () => {
      clearInterval(autoScroll);
      container.removeEventListener("mouseenter", pause);
      container.removeEventListener("mouseleave", resume);
    };
  }, []);

  return (
    <div className="gerugambakkam-dental-page">
      {/* Floating Navigation */}

      {/* Hero Section with Video Background */}
      <section
        className="gerugambakkam-dental-hero"
        style={{
          backgroundImage: `url('https://images.unsplash.com/photo-1629909613654-28e377c37b09?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1920&q=80')`,
        }}
      >
        <div className="gerugambakkam-dental-hero-overlay"></div>
        <div className="gerugambakkam-dental-hero-content">
          <div className="gerugambakkam-dental-hero-logo">
            <div className="gerugambakkam-dental-logo-icon">
              <img
                src="https://img.icons8.com/fluency/96/tooth.png"
                alt="Tooth icon"
              />
            </div>
            <h1 className="gerugambakkam-dental-hero-title">
              H-CURA Gerugambakkam
            </h1>
          </div>
          <h2 className="gerugambakkam-dental-hero-subtitle">
            Best Dental Clinic in Gerugambakkam, Chennai
          </h2>
          <p className="gerugambakkam-dental-hero-description">
            Modern Dental Expertise with a Gentle Neighbourhood Touch
          </p>
          <div className="gerugambakkam-dental-hero-buttons">
            <a href="#book" className="gerugambakkam-dental-primary-button">
              Book Consultation
            </a>
            <a
              href="#treatments"
              className="gerugambakkam-dental-secondary-button"
            >
              Explore Treatments
            </a>
          </div>
          <div className="gerugambakkam-dental-hero-features">
            <div className="gerugambakkam-dental-hero-feature">
              <img
                src="https://img.icons8.com/fluency/48/certificate.png"
                alt="Certificate"
              />
              <span>Award-Winning Care</span>
            </div>

            <div className="gerugambakkam-dental-hero-feature">
              <img
                src="https://img.icons8.com/fluency/48/innovation.png"
                alt="Innovation"
              />
              <span>Latest Technology</span>
            </div>
          </div>
        </div>
        <div className="gerugambakkam-dental-scroll-indicator">
          <div className="gerugambakkam-dental-mouse">
            <div className="gerugambakkam-dental-wheel"></div>
          </div>
          <div className="gerugambakkam-dental-scroll-text">
            Scroll to explore
          </div>
        </div>
      </section>
      {/* About Section with Parallax */}
      <section id="about" className="gerugambakkam-dental-about">
        <div className="gerugambakkam-dental-parallax-bg"></div>
        <div className="gerugambakkam-dental-container">
          <div className="gerugambakkam-dental-about-content">
            <div
              className={`gerugambakkam-dental-section-header animate-on-scroll ${
                isAnimating["about-header"] ? "animate" : ""
              }`}
              id="about-header"
            >
              <span className="gerugambakkam-dental-section-subtitle">
                About H-CURA
              </span>
              <h2 className="gerugambakkam-dental-section-title">
                Redefining Dental Excellence
              </h2>
              <div className="gerugambakkam-dental-title-line"></div>
            </div>
            <div className="gerugambakkam-dental-about-grid">
              <div className="gerugambakkam-dental-about-image">
                <img
                  src="https://images.unsplash.com/photo-1588776814601-a454a8e3a940?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80"
                  alt="Modern dental clinic"
                />
                <div className="gerugambakkam-dental-about-experience">
                  <span className="gerugambakkam-dental-experience-number">
                    3+
                  </span>
                  <span className="gerugambakkam-dental-experience-text">
                    Years of Excellence
                  </span>
                </div>
              </div>
              <div
                className={`gerugambakkam-dental-about-text animate-on-scroll ${
                  isAnimating["about-text"] ? "animate" : ""
                }`}
                id="about-text"
              >
                <p>
                  Searching for the best dental clinic in Gerugambakkam? At
                  Hcura Dental Clinic, we bring together world-class dental care
                  with the warmth of personalized attention. Whether you need a
                  smile makeover, dental implants, or routine oral checkups,
                  we’re your go-to family dental clinic near Mangadu and Porur.
                </p>
                <p>
                  Located close to Kolapakkam, Kundrathur, and Porur, we’re a
                  preferred choice for families, working professionals, and
                  elderly patients looking for a reliable dentist in
                  Gerugambakkam Chennai.
                </p>
                <div className="gerugambakkam-dental-about-stats">
                  <div className="gerugambakkam-dental-stat">
                    <span className="gerugambakkam-dental-stat-number">
                      1,000+
                    </span>
                    <span className="gerugambakkam-dental-stat-text">
                      Smiles Transformed
                    </span>
                  </div>
                  <div className="gerugambakkam-dental-stat">
                    <span className="gerugambakkam-dental-stat-number">
                      98%
                    </span>
                    <span className="gerugambakkam-dental-stat-text">
                      Patient Satisfaction
                    </span>
                  </div>
                  <div className="gerugambakkam-dental-stat">
                    <span className="gerugambakkam-dental-stat-number">5</span>
                    <span className="gerugambakkam-dental-stat-text">
                      Specialist Doctors
                    </span>
                  </div>
                </div>
                <a href="#team" className="gerugambakkam-dental-text-button">
                  <span className="gerugambakkam-dental-arrow">→</span>
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/*  */}
      <section
        id="why-choose-section"
        className="gerugambakkam-why-choose-section"
      >
        <div className="gerugambakkam-why-choose-container">
          <div className="gerugambakkam-why-choose-header">
            <h2 className="gerugambakkam-why-choose-title">
              Why Hcura Dental Clinic is the Choice of Thousands Across
              Gerugambakkam, Chennai
            </h2>
          </div>

          <div className="gerugambakkam-why-choose-cards">
            <div className="gerugambakkam-why-choose-card">
              <h3>Multicity Presence With Consistent Quality</h3>
              <p>
                We proudly operate across multiple cities, bringing the same
                level of advanced care, skilled professionals, and ethical
                treatment to every location.
              </p>
            </div>

            <div className="gerugambakkam-why-choose-card">
              <h3>India's Top Dental Experts Under One Brand</h3>
              <p>
                {" "}
                our team consists of MDS-qualified dentists experienced in
                general, cosmetic, pediatric, and surgical dental care.
              </p>
            </div>

            <div className="gerugambakkam-why-choose-card">
              <h3>Personalised Care Tailored to Local Communities</h3>
              <p>
                Whether it's a metro-city high-rise or a growing township, our
                approach is rooted in understanding and serving the unique
                dental health needs of the community we're in.
              </p>
            </div>

            <div className="gerugambakkam-why-choose-card">
              <h3>Pain-Free, Modern Dentistry</h3>
              <p>
                Our clinics are equipped with digital X-rays, laser tools,
                invisible aligner technology, and other innovations for safer,
                faster, and more comfortable procedures.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Treatments Section with Filter Tabs */}
      <section id="treatments" className="gerugambakkam-dental-treatments">
        <div className="gerugambakkam-dental-container">
          <div
            className={`gerugambakkam-dental-section-header animate-on-scroll ${
              isAnimating["treatments-header"] ? "animate" : ""
            }`}
            id="treatments-header"
          >
            <span className="gerugambakkam-dental-section-subtitle">
              Our Services
            </span>
            <h2 className="gerugambakkam-dental-section-title">
              Advanced Dental Treatments
            </h2>
            <div className="gerugambakkam-dental-title-line"></div>
          </div>

          {/* Main Category Tabs */}
          <div className="gerugambakkam-dental-tabs">
            <button
              className={`gerugambakkam-dental-tab ${
                activeTab === "all" && !expandedCategory ? "active" : ""
              }`}
              onClick={() => handleTabClick("all")}
            >
              All Treatments
            </button>
            <button
              className={`gerugambakkam-dental-tab ${
                activeTab === "general" || expandedCategory === "general"
                  ? "active"
                  : ""
              }`}
              onClick={() => handleTabClick("general")}
            >
              General Dentistry
            </button>
            <button
              className={`gerugambakkam-dental-tab ${
                activeTab === "endodontics" ||
                expandedCategory === "endodontics"
                  ? "active"
                  : ""
              }`}
              onClick={() => handleTabClick("endodontics")}
            >
              Endodontics
            </button>
            <button
              className={`gerugambakkam-dental-tab ${
                activeTab === "prostho" || expandedCategory === "prostho"
                  ? "active"
                  : ""
              }`}
              onClick={() => handleTabClick("prostho")}
            >
              Prosthodontics
            </button>
            <button
              className={`gerugambakkam-dental-tab ${
                activeTab === "perio" || expandedCategory === "perio"
                  ? "active"
                  : ""
              }`}
              onClick={() => handleTabClick("perio")}
            >
              Periodontics
            </button>
            <button
              className={`gerugambakkam-dental-tab ${
                activeTab === "omfs" || expandedCategory === "omfs"
                  ? "active"
                  : ""
              }`}
              onClick={() => handleTabClick("omfs")}
            >
              OMFS
            </button>
            <button
              className={`gerugambakkam-dental-tab ${
                activeTab === "pedo" || expandedCategory === "pedo"
                  ? "active"
                  : ""
              }`}
              onClick={() => handleTabClick("pedo")}
            >
              Pediatric
            </button>
            <button
              className={`gerugambakkam-dental-tab ${
                activeTab === "ortho" || expandedCategory === "ortho"
                  ? "active"
                  : ""
              }`}
              onClick={() => handleTabClick("ortho")}
            >
              Orthodontics
            </button>
            <button
              className={`gerugambakkam-dental-tab ${
                activeTab === "implants" || expandedCategory === "implants"
                  ? "active"
                  : ""
              }`}
              onClick={() => handleTabClick("implants")}
            >
              Implants
            </button>
          </div>

          {/* Main Categories Grid - Shows when "All Treatments" is selected and no category is expanded */}
          {activeTab === "all" && !expandedCategory && (
            <div
              className={`gerugambakkam-dental-categories-grid animate-on-scroll ${
                isAnimating["categories-grid"] ? "animate" : ""
              }`}
              id="categories-grid"
            >
              {categories.map((category) => (
                <div
                  key={category.id}
                  className="gerugambakkam-dental-category-card"
                  onClick={() => handleCategoryClick(category.id)}
                >
                  <div className="gerugambakkam-dental-category-image-container">
                    <div
                      className="gerugambakkam-dental-category-image"
                      style={{ backgroundImage: `url(${category.image})` }}
                    >
                      <div className="gerugambakkam-dental-category-overlay">
                        <img
                          src={category.icon}
                          alt={category.name}
                          className="gerugambakkam-dental-category-icon"
                        />
                      </div>
                    </div>
                  </div>
                  <div className="gerugambakkam-dental-category-content">
                    <h3 className="gerugambakkam-dental-category-title">
                      {category.name}
                    </h3>
                    <p className="gerugambakkam-dental-category-description">
                      {category.description}
                    </p>
                    <div className="gerugambakkam-dental-category-link">
                      <span>View Treatments</span>
                      <span className="gerugambakkam-dental-arrow">→</span>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )}

          {/* Sub-treatments Grid - Shows when a specific tab is selected or when a category is expanded */}
          {(activeTab !== "all" || expandedCategory) && (
            <>
              {/* Category Title and Back Button */}
              <div className="gerugambakkam-dental-category-header">
                <h3 className="gerugambakkam-dental-category-main-title">
                  {expandedCategory
                    ? categories.find((cat) => cat.id === expandedCategory)
                        ?.name
                    : categories.find((cat) => cat.id === activeTab)?.name}{" "}
                  Treatments
                </h3>
                <button
                  className="gerugambakkam-dental-back-button"
                  onClick={() =>
                    activeTab === "all"
                      ? setExpandedCategory(null)
                      : handleTabClick("all")
                  }
                >
                  <span className="gerugambakkam-dental-back-arrow">←</span>{" "}
                  Back to{" "}
                  {activeTab === "all" ? "All Treatments" : "Main Categories"}
                </button>
              </div>

              {/* Sub-treatments Grid */}
              <div
                className={`gerugambakkam-dental-treatments-grid animate-on-scroll ${
                  isAnimating["treatments-grid"] ? "animate" : ""
                }`}
                id="treatments-grid"
              >
                {/* Filter treatments based on the active tab or expanded category */}
                {(activeTab !== "all"
                  ? categories.find((cat) => cat.id === activeTab)?.treatments
                  : categories.find((cat) => cat.id === expandedCategory)
                      ?.treatments
                )?.map((treatment) => (
                  <div
                    key={treatment.id}
                    className="gerugambakkam-dental-treatment-card"
                    onClick={() =>
                      (window.location.href = `/treatment/${
                        activeTab !== "all" ? activeTab : expandedCategory
                      }/${treatment.id}`)
                    }
                  >
                    <div className="gerugambakkam-dental-treatment-image-container">
                      <div
                        className="gerugambakkam-dental-treatment-image"
                        style={{ backgroundImage: `url(${treatment.image})` }}
                      >
                        <div className="gerugambakkam-dental-treatment-overlay">
                          <img
                            src={treatment.icon}
                            alt={treatment.title}
                            className="gerugambakkam-dental-treatment-icon"
                          />
                        </div>
                      </div>
                    </div>
                    <div className="gerugambakkam-dental-treatment-content">
                      <h3 className="gerugambakkam-dental-treatment-title">
                        {treatment.title}
                      </h3>
                      <p className="gerugambakkam-dental-treatment-description">
                        {treatment.description}
                      </p>
                      <div className="gerugambakkam-dental-treatment-link">
                        <span>Learn More</span>
                        <span className="gerugambakkam-dental-arrow">→</span>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </>
          )}
        </div>
      </section>

      {/* Technology Showcase */}
      <section id="technology" className="gerugambakkam-dental-technology">
        <div className="gerugambakkam-dental-container">
          <div
            className={`gerugambakkam-dental-section-header animate-on-scroll ${
              isAnimating["tech-header"] ? "animate" : ""
            }`}
            id="tech-header"
          >
            <span className="gerugambakkam-dental-section-subtitle">
              Cutting-Edge Innovation
            </span>
            <h2 className="gerugambakkam-dental-section-title">
              Our Advanced Technology
            </h2>
            <div className="gerugambakkam-dental-title-line"></div>
          </div>

          <div
            className={`gerugambakkam-dental-tech-showcase animate-on-scroll ${
              isAnimating["tech-showcase"] ? "animate" : ""
            }`}
            id="tech-showcase"
          >
            <div className="gerugambakkam-dental-tech-image">
              <img
                src="https://images.unsplash.com/photo-1597765221336-1f65bb4c4fee?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80"
                alt="Dental technology"
              />
            </div>
            <div className="gerugambakkam-dental-tech-content">
              <p className="gerugambakkam-dental-tech-intro">
                At H-CURA, we invest in the latest dental technologies to
                provide precise, comfortable, and efficient treatments that
                deliver exceptional results.
              </p>

              <div className="gerugambakkam-dental-tech-grid">
                {technologies.map((tech) => (
                  <div key={tech.id} className="gerugambakkam-dental-tech-card">
                    <div className="gerugambakkam-dental-tech-icon">
                      <img src={tech.icon} alt={tech.title} />
                    </div>
                    <div className="gerugambakkam-dental-tech-info">
                      <h3 className="gerugambakkam-dental-tech-title">
                        {tech.title}
                      </h3>
                      <p className="gerugambakkam-dental-tech-description">
                        {tech.description}
                      </p>
                    </div>
                  </div>
                ))}
              </div>

              <a href="#book" className="gerugambakkam-dental-primary-button">
                Experience Our Technology
              </a>
            </div>
          </div>
        </div>
      </section>

      {/*  */}
      <section
        id="who-we-serve-section"
        className="gerugambakkam-who-we-serve-section"
      >
        <div className="gerugambakkam-who-we-serve-container">
          <div className="gerugambakkam-who-we-serve-header">
            <span className="gerugambakkam-who-we-serve-tagline">
              Comprehensive Care
            </span>
            <h2 className="gerugambakkam-who-we-serve-title">Who We Serve</h2>
            <p className="gerugambakkam-who-we-serve-subtitle">
              Our dental care is designed for every age group, every occupation,
              and every corner of the country:
            </p>
          </div>

          <div className="gerugambakkam-who-we-serve-boxes">
            <div className="gerugambakkam-serve-box">
              <div className="gerugambakkam-serve-box-icon">
                <svg
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M12 12C14.21 12 16 10.21 16 8C16 5.79 14.21 4 12 4C9.79 4 8 5.79 8 8C8 10.21 9.79 12 12 12ZM12 14C9.33 14 4 15.34 4 18V20H20V18C20 15.34 14.67 14 12 14Z"
                    fill="currentColor"
                  />
                </svg>
              </div>
              <div className="gerugambakkam-serve-box-content">
                <h3>Children</h3>
                <p>Requiring preventive care or braces</p>
              </div>
            </div>

            <div className="gerugambakkam-serve-box">
              <div className="gerugambakkam-serve-box-icon">
                <svg
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M20 7H16V5L14 3H10L8 5V7H4C2.9 7 2 7.9 2 9V14C2 14.75 2.4 15.38 3 15.73V19C3 20.11 3.89 21 5 21H19C20.11 21 21 20.11 21 19V15.72C21.59 15.37 22 14.73 22 14V9C22 7.9 21.1 7 20 7ZM10 5H14V7H10V5ZM4 9H20V14H15V11H9V14H4V9ZM13 15H11V13H13V15ZM19 19H5V16H9V17H15V16H19V19Z"
                    fill="currentColor"
                  />
                </svg>
              </div>
              <div className="gerugambakkam-serve-box-content">
                <h3>College Students & Professionals</h3>
                <p>Needing cosmetic enhancements</p>
              </div>
            </div>

            <div className="gerugambakkam-serve-box">
              <div className="gerugambakkam-serve-box-icon">
                <svg
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M12.5 11.95C14.05 11.95 15.45 10.78 15.45 8.92C15.45 7.13 14.05 6 12.5 6C10.95 6 9.55 7.13 9.55 8.92C9.55 10.78 10.95 11.95 12.5 11.95ZM12.5 7.5C13.05 7.5 13.95 8.05 13.95 8.92C13.95 9.87 13.05 10.45 12.5 10.45C11.95 10.45 11.05 9.87 11.05 8.92C11.05 8.05 11.95 7.5 12.5 7.5ZM5.5 6C4.45 6 3.45 6.9 3.45 8.5C3.45 9.95 4.35 10.5 5.4 10.5C6.45 10.5 7.5 9.75 7.5 8.5C7.5 7 6.55 6 5.5 6ZM19.5 6C18.45 6 17.5 7 17.5 8.5C17.5 9.75 18.55 10.5 19.6 10.5C20.65 10.5 21.55 9.95 21.55 8.5C21.55 6.9 20.55 6 19.5 6ZM5.5 12C3.15 12 1 13.39 1 15.55V17H10V15.55C10 13.39 7.85 12 5.5 12ZM2.5 15.55C2.5 14.5 3.96 13.5 5.5 13.5C7.04 13.5 8.5 14.5 8.5 15.55V15.5H2.5V15.55ZM19.5 12C17.15 12 15 13.39 15 15.55V17H24V15.55C24 13.39 21.85 12 19.5 12ZM16.5 15.55C16.5 14.5 17.96 13.5 19.5 13.5C21.04 13.5 22.5 14.5 22.5 15.55V15.5H16.5V15.55ZM12.5 13C9.65 13 7 14.7 7 17.25V19H18V17.25C18 14.7 15.35 13 12.5 13ZM8.5 17.25C8.5 15.7 10.4 14.5 12.5 14.5C14.6 14.5 16.5 15.7 16.5 17.25V17.5H8.5V17.25Z"
                    fill="currentColor"
                  />
                </svg>
              </div>
              <div className="gerugambakkam-serve-box-content">
                <h3>Parents</h3>
                <p>Juggling work and family dental schedules</p>
              </div>
            </div>

            <div className="gerugambakkam-serve-box">
              <div className="gerugambakkam-serve-box-icon">
                <svg
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M13.5 5.5C14.6 5.5 15.5 4.6 15.5 3.5C15.5 2.4 14.6 1.5 13.5 1.5C12.4 1.5 11.5 2.4 11.5 3.5C11.5 4.6 12.4 5.5 13.5 5.5ZM9 8.5H17C18.1 8.5 19 7.6 19 6.5C19 5.4 18.1 4.5 17 4.5C15.9 4.5 14.35 4.5 13.25 4.5C12.15 4.5 12.15 4.5 11.05 4.5C8.9 4.5 7 6.4 7 8.5V13.5C7 14.33 7.67 15 8.5 15H9V22.5H11V15H13V22.5H15V15H16.5C17.33 15 18 14.33 18 13.5V10.5H9V8.5Z"
                    fill="currentColor"
                  />
                </svg>
              </div>
              <div className="gerugambakkam-serve-box-content">
                <h3>Senior Citizens</h3>
                <p>With complex restorative needs</p>
              </div>
            </div>

            <div className="gerugambakkam-serve-box">
              <div className="gerugambakkam-serve-box-icon">
                <svg
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M19 3H14.82C14.4 1.84 13.3 1 12 1C10.7 1 9.6 1.84 9.18 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3ZM12 3C12.55 3 13 3.45 13 4C13 4.55 12.55 5 12 5C11.45 5 11 4.55 11 4C11 3.45 11.45 3 12 3ZM12 7C13.66 7 15 8.34 15 10C15 11.66 13.66 13 12 13C10.34 13 9 11.66 9 10C9 8.34 10.34 7 12 7ZM18 19H6V17.6C6 15.6 10 14.5 12 14.5C14 14.5 18 15.6 18 17.6V19Z"
                    fill="currentColor"
                  />
                </svg>
              </div>
              <div className="gerugambakkam-serve-box-content">
                <h3>Individuals with Medical Conditions</h3>
                <p>Needing safe and hygienic oral care</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Why Choose Us Section */}
      <section id="why-choose-us" className="gerugambakkam-dental-why-choose">
        <div className="gerugambakkam-dental-container">
          <div
            className={`gerugambakkam-dental-section-header animate-on-scroll ${
              isAnimating["why-choose-header"] ? "animate" : ""
            }`}
            id="why-choose-header"
          >
            <span className="gerugambakkam-dental-section-subtitle">
              Why Choose Us
            </span>
            <h2 className="gerugambakkam-dental-section-title">
              Trusted Dental Care In Girukambakkam , Chennai
            </h2>
            <div className="gerugambakkam-dental-title-line"></div>
          </div>

          <div className="gerugambakkam-dental-row">
            {/* Left Side Box */}
            <div
              className={`gerugambakkam-dental-col gerugambakkam-dental-why-choose-left animate-on-scroll ${
                isAnimating["why-choose-content"] ? "animate" : ""
              }`}
              id="why-choose-content"
            >
              <div className="gerugambakkam-dental-why-choose-content">
                <h2>Hcura Dentists – Professionals You Can Trust</h2>
                <p>
                  We handpick qualified and compassionate dentists for every
                  city we operate in. Our doctors undergo training to maintain
                  uniform quality of care — from metro cities to tier-2 towns.
                </p>

                <h3>Patients trust us because:</h3>
                <ul className="gerugambakkam-dental-trust-points">
                  <li>We never upsell unnecessary treatments.</li>
                  <li>We educate before we treat.</li>
                  <li>We follow through with post-treatment care.</li>
                </ul>
              </div>
            </div>

            {/* Right Side Box - Before & After Gallery */}
            <div
              className={`gerugambakkam-dental-col gerugambakkam-dental-why-choose-right animate-on-scroll ${
                isAnimating["mini-gallery"] ? "animate" : ""
              }`}
              id="mini-gallery"
            >
              <div className="gerugambakkam-dental-mini-gallery">
                <h3 className="gerugambakkam-dental-mini-gallery-title">
                  Before & After Results
                </h3>

                <div className="gerugambakkam-dental-mini-gallery-slider">
                  {galleryItems.map((item, index) => (
                    <div
                      key={item.id}
                      className={`gerugambakkam-dental-gallery-item ${
                        index === activeGalleryItem ? "active" : ""
                      }`}
                    >
                      <div className="gerugambakkam-dental-comparison">
                        <div className="gerugambakkam-dental-before">
                          <img
                            src={item.before}
                            alt={`Before ${item.treatment}`}
                          />
                          <span className="gerugambakkam-dental-label">
                            Before
                          </span>
                        </div>
                        <div className="gerugambakkam-dental-after">
                          <img
                            src={item.after}
                            alt={`After ${item.treatment}`}
                          />
                          <span className="gerugambakkam-dental-label">
                            After
                          </span>
                        </div>
                      </div>
                      <div className="gerugambakkam-dental-mini-gallery-caption">
                        <p>{item.treatment}</p>
                      </div>
                    </div>
                  ))}
                </div>

                <div className="gerugambakkam-dental-gallery-nav">
                  {galleryItems.map((_, index) => (
                    <button
                      key={index}
                      className={`gerugambakkam-dental-gallery-dot ${
                        index === activeGalleryItem ? "active" : ""
                      }`}
                      onClick={() => setActiveGalleryItem(index)}
                      aria-label={`View gallery item ${index + 1}`}
                    ></button>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Testimonials with Video */}

      <section id="testimonials" className="gerugambakkam-dental-testimonials">
        <div className="gerugambakkam-dental-container">
          <div
            className={`gerugambakkam-dental-section-header animate-on-scroll ${
              isAnimating["testimonials-header"] ? "animate" : ""
            }`}
            id="testimonials-header"
          >
            <span className="gerugambakkam-dental-section-subtitle">
              Patient Stories
            </span>
            <h2 className="gerugambakkam-dental-section-title">
              What Our Patients Say
            </h2>
            <div className="gerugambakkam-dental-title-line"></div>
          </div>

          <div
            className="gerugambakkam-testimonial-cards-horizontal-scroll"
            ref={testimonialScrollRef}
          >
            {testimonials.map((testimonial, index) => (
              <div
                key={index}
                className="gerugambakkam-testimonial-carousel-item"
              >
                <div className="gerugambakkam-dental-testimonial-box">
                  <div className="gerugambakkam-dental-testimonial-content">
                    <div className="gerugambakkam-dental-quote-icon">
                      <img
                        src="https://img.icons8.com/fluency/48/quote-left.png"
                        alt="Quote"
                      />
                    </div>
                    <p className="gerugambakkam-dental-quote">
                      {testimonial.quote}
                    </p>
                    <div className="gerugambakkam-dental-patient-info">
                      <div className="gerugambakkam-dental-patient-details">
                        <div className="gerugambakkam-dental-patient-name">
                          {testimonial.name}
                        </div>
                        <div className="gerugambakkam-dental-patient-treatment">
                          {testimonial.treatment}
                        </div>
                        <div className="gerugambakkam-dental-rating">
                          {[...Array(testimonial.rating)].map((_, i) => (
                            <span key={i} className="gerugambakkam-dental-star">
                              ★
                            </span>
                          ))}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Team Section */}
      <section id="team" className="gerugambakkam-dental-team">
        <div className="gerugambakkam-dental-container">
          <div
            className={`gerugambakkam-dental-section-header animate-on-scroll ${
              isAnimating["team-header"] ? "animate" : ""
            }`}
            id="team-header"
          >
            <span className="gerugambakkam-dental-section-subtitle">
              Expert Specialists
            </span>
            <h2 className="gerugambakkam-dental-section-title">
              Meet Our Doctors
            </h2>
            <div className="gerugambakkam-dental-title-line"></div>
          </div>

          <div
            className={`gerugambakkam-dental-team-grid animate-on-scroll ${
              isAnimating["team-grid"] ? "animate" : ""
            }`}
            id="team-grid"
          >
            {teamMembers.map((member) => (
              <div key={member.id} className="gerugambakkam-dental-team-member">
                <div className="gerugambakkam-dental-member-image">
                  <img src={member.image} alt={member.name} />
                </div>
                <div className="gerugambakkam-dental-member-info">
                  <h3 className="gerugambakkam-dental-member-name">
                    {member.name}
                  </h3>
                  <p className="gerugambakkam-dental-member-role">
                    {member.role}
                  </p>
                  <p className="gerugambakkam-dental-member-bio">
                    {member.bio}
                  </p>
                  <div className="gerugambakkam-dental-member-social">
                    <a href="#" className="gerugambakkam-dental-social-icon">
                      <img
                        src="https://img.icons8.com/fluency/48/linkedin.png"
                        alt="LinkedIn"
                      />
                    </a>
                    <a href="#" className="gerugambakkam-dental-social-icon">
                      <img
                        src="https://img.icons8.com/fluency/48/instagram-new.png"
                        alt="Instagram"
                      />
                    </a>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
      {/* Booking Section */}
      {/* Booking Section */}
      <section id="book" className="gerugambakkam-dental-booking">
        <div className="gerugambakkam-dental-booking-bg"></div>
        <div className="gerugambakkam-dental-container">
          <div
            className={`gerugambakkam-dental-section-header animate-on-scroll ${
              isAnimating["booking-header"] ? "animate" : ""
            }`}
            id="booking-header"
          >
            <span className="gerugambakkam-dental-section-subtitle">
              Schedule Your Visit
            </span>
            <h2 className="gerugambakkam-dental-section-title">
              Book Your Consultation
            </h2>
            <div className="gerugambakkam-dental-title-line"></div>
          </div>

          <div
            className={`gerugambakkam-dental-booking-container animate-on-scroll ${
              isAnimating["booking-container"] ? "animate" : ""
            }`}
            id="booking-container"
          >
            <div className="gerugambakkam-dental-booking-info">
              <div className="gerugambakkam-dental-booking-text">
                <p>
                  Take the first step towards your perfect smile. Our team of
                  specialists is ready to create a personalized treatment plan
                  that meets your unique needs and goals.
                </p>
                <div className="gerugambakkam-dental-booking-features">
                  <div className="gerugambakkam-dental-booking-feature">
                    <img
                      src="https://img.icons8.com/fluency/48/calendar-week.png"
                      alt="Calendar"
                    />
                    <span>EMI Options</span>
                  </div>
                </div>
                <div className="gerugambakkam-dental-contact-info">
                  <div className="gerugambakkam-dental-contact-item">
                    <img
                      src="https://img.icons8.com/fluency/48/phone.png"
                      alt="Phone"
                    />
                    <div className="gerugambakkam-dental-contact-details">
                      <h4>Call Us</h4>
                      <p>8870001377</p>
                    </div>
                  </div>
                  <div className="gerugambakkam-dental-contact-item">
                    <img
                      src="https://img.icons8.com/fluency/48/new-post.png"
                      alt="Email"
                    />
                    <div className="gerugambakkam-dental-contact-details">
                      <h4>Email Us</h4>
                      <p>appointments@hcuradental.com</p>
                    </div>
                  </div>
                  <div className="gerugambakkam-dental-contact-item">
                    <img
                      src="https://img.icons8.com/fluency/48/marker.png"
                      alt="Location"
                    />
                    <div className="gerugambakkam-dental-contact-details">
                      <h4>Visit Us</h4>
                      <p>
                        No:779&780 2nd Floor, Sai Towers Building, South, E End
                        Main Rd, Bengaluru, Karnataka 560069, India
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="gerugambakkam-dental-booking-form">
              <form>
                <div className="gerugambakkam-dental-form-group">
                  <label htmlFor="name">Full Name</label>
                  <input
                    type="text"
                    id="name"
                    name="name"
                    placeholder="Enter your full name"
                    required
                  />
                </div>

                <div className="gerugambakkam-dental-form-row">
                  <div className="gerugambakkam-dental-form-group">
                    <label htmlFor="email">Email Address</label>
                    <input
                      type="email"
                      id="email"
                      name="email"
                      placeholder="Enter your email"
                      required
                    />
                  </div>
                  <div className="gerugambakkam-dental-form-group">
                    <label htmlFor="phone">Phone Number</label>
                    <input
                      type="tel"
                      id="phone"
                      name="phone"
                      placeholder="Enter your phone number"
                      required
                    />
                  </div>
                </div>

                <div className="gerugambakkam-dental-form-row">
                  <div className="gerugambakkam-dental-form-group">
                    <label htmlFor="date">Preferred Date</label>
                    <input type="date" id="date" name="date" required />
                  </div>
                  <div className="gerugambakkam-dental-form-group">
                    <label htmlFor="time">Preferred Time</label>
                    <select id="time" name="time" required>
                      <option value="">Select Time</option>
                      <option value="morning">Morning (9am - 12pm)</option>
                      <option value="afternoon">Afternoon (12pm - 3pm)</option>
                      <option value="evening">Evening (3pm - 6pm)</option>
                    </select>
                  </div>
                </div>

                <div className="gerugambakkam-dental-form-group">
                  <label htmlFor="service">Service Interested In</label>
                  <select id="service" name="service" required>
                    <option value="">Select Service</option>
                    {categories.map((category) => (
                      <option key={category.id} value={category.id}>
                        {category.name}
                      </option>
                    ))}
                  </select>
                </div>

                <div className="gerugambakkam-dental-form-group">
                  <label htmlFor="message">Additional Information</label>
                  <textarea
                    id="message"
                    name="message"
                    placeholder="Tell us more about your dental needs"
                    rows="3"
                  ></textarea>
                </div>

                <button
                  type="submit"
                  className="gerugambakkam-dental-submit-button"
                >
                  Book Appointment
                </button>
              </form>
            </div>
          </div>
          {/* Our Dental Clinics Section */}
        </div>
      </section>

      <section id="our-clinics" className="jayanagar-dental-clinics">
  <div className="jayanagar-dental-container">
    <div
      className={`jayanagar-dental-section-header animate-on-scroll ${
        isAnimating["clinics-header"] ? "animate" : ""
      }`}
      id="clinics-header"
    >
      <span className="jayanagar-dental-section-subtitle">
        Explore Our Locations
      </span>
      <h2 className="jayanagar-dental-section-title">
        Find Your Nearest Clinic
      </h2>
      <div className="jayanagar-dental-title-line"></div>
      <p className="jayanagar-dental-clinics-intro">
        Click on a location to discover our specialized services and
        facilities
      </p>
    </div>

    <div
      className={`jayanagar-dental-clinics-interactive animate-on-scroll ${
        isAnimating["clinics-grid"] ? "animate" : ""
      }`}
      id="clinics-grid"
    >
      <div
        className="jayanagar-dental-clinic-card-3d"
        onClick={() => (window.location.href = "/dental-treatment")}
      >
        <div className="jayanagar-dental-clinic-card-inner">
          <div className="jayanagar-dental-clinic-image-container">
            <div
              className="jayanagar-dental-clinic-image"
              style={{
                backgroundImage: `url('https://images.unsplash.com/photo-1606811856475-5e6fcdc6e509?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=60')`,
              }}
            >
              <div className="jayanagar-dental-clinic-overlay">
                <div className="jayanagar-dental-clinic-badge">
                  Flagship
                </div>
                <img
                  src="https://img.icons8.com/fluency/96/marker.png"
                  alt="Location"
                  className="jayanagar-dental-clinic-icon"
                />
              </div>
            </div>
          </div>
          <div className="jayanagar-dental-clinic-content">
            <div className="jayanagar-dental-clinic-header">
              <h3 className="jayanagar-dental-clinic-title">Jayanagar</h3>
              <div className="jayanagar-dental-clinic-rating">
                <span className="jayanagar-dental-clinic-star">★</span>
                <span className="jayanagar-dental-clinic-star">★</span>
                <span className="jayanagar-dental-clinic-star">★</span>
                <span className="jayanagar-dental-clinic-star">★</span>
                <span className="jayanagar-dental-clinic-star">★</span>
                <span className="jayanagar-dental-clinic-reviews">
                  (120+)
                </span>
              </div>
            </div>
            <p className="jayanagar-dental-clinic-description">
              Our flagship clinic with state-of-the-art facilities and
              expert specialists.
            </p>
            <div className="jayanagar-dental-clinic-features">
              <span className="jayanagar-dental-clinic-feature">
                <img
                  src="https://img.icons8.com/fluency/48/certificate.png"
                  alt="Certificate"
                />
                Premium Care
              </span>
              <span className="jayanagar-dental-clinic-feature">
                <img
                  src="https://img.icons8.com/fluency/48/technology.png"
                  alt="Technology"
                />
                Advanced Tech
              </span>
            </div>
            <div className="jayanagar-dental-clinic-cta">
              <span>View Details</span>
              <span className="jayanagar-dental-clinic-arrow">→</span>
            </div>
          </div>
        </div>
      </div>

      <div
        className="jayanagar-dental-clinic-card-3d"
        onClick={() => (window.location.href = "/dental-treatment")}
      >
        <div className="jayanagar-dental-clinic-card-inner">
          <div className="jayanagar-dental-clinic-image-container">
            <div
              className="jayanagar-dental-clinic-image"
              style={{
                backgroundImage: `url('https://images.unsplash.com/photo-1598256989800-fe5f95da9787?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=60')`,
              }}
            >
              <div className="jayanagar-dental-clinic-overlay">
                <div className="jayanagar-dental-clinic-badge">
                  Cosmetic
                </div>
                <img
                  src="https://img.icons8.com/fluency/96/marker.png"
                  alt="Location"
                  className="jayanagar-dental-clinic-icon"
                />
              </div>
            </div>
          </div>
          <div className="jayanagar-dental-clinic-content">
            <div className="jayanagar-dental-clinic-header">
              <h3 className="jayanagar-dental-clinic-title">
                Main Page
              </h3>
              <div className="jayanagar-dental-clinic-rating">
                <span className="jayanagar-dental-clinic-star">★</span>
                <span className="jayanagar-dental-clinic-star">★</span>
                <span className="jayanagar-dental-clinic-star">★</span>
                <span className="jayanagar-dental-clinic-star">★</span>
                <span className="jayanagar-dental-clinic-star">★</span>
                <span className="jayanagar-dental-clinic-reviews">
                  (98+)
                </span>
              </div>
            </div>
            <p className="jayanagar-dental-clinic-description">
              Modern facility specializing in cosmetic and restorative
              treatments.
            </p>
            <div className="jayanagar-dental-clinic-features">
              <span className="jayanagar-dental-clinic-feature">
                <img
                  src="https://img.icons8.com/fluency/48/smile.png"
                  alt="Smile"
                />
                Smile Design
              </span>
              <span className="jayanagar-dental-clinic-feature">
                <img
                  src="https://img.icons8.com/fluency/48/tooth-cleaning.png"
                  alt="Restoration"
                />
                Restoration
              </span>
            </div>
            <div className="jayanagar-dental-clinic-cta">
              <span>View Details</span>
              <span className="jayanagar-dental-clinic-arrow">→</span>
            </div>
          </div>
        </div>
      </div>

      <div
        className="jayanagar-dental-clinic-card-3d"
        onClick={() => (window.location.href = "/clinics/valasaravakam")}
      >
        <div className="jayanagar-dental-clinic-card-inner">
          <div className="jayanagar-dental-clinic-image-container">
            <div
              className="jayanagar-dental-clinic-image"
              style={{
                backgroundImage: `url('https://images.unsplash.com/photo-1588776814546-1ffcf47267a5?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=60')`,
              }}
            >
              <div className="jayanagar-dental-clinic-overlay">
                <div className="jayanagar-dental-clinic-badge">
                  Family
                </div>
                <img
                  src="https://img.icons8.com/fluency/96/marker.png"
                  alt="Location"
                  className="jayanagar-dental-clinic-icon"
                />
              </div>
            </div>
          </div>
          <div className="jayanagar-dental-clinic-content">
            <div className="jayanagar-dental-clinic-header">
              <h3 className="jayanagar-dental-clinic-title">
                Valasaravakam
              </h3>
              <div className="jayanagar-dental-clinic-rating">
                <span className="jayanagar-dental-clinic-star">★</span>
                <span className="jayanagar-dental-clinic-star">★</span>
                <span className="jayanagar-dental-clinic-star">★</span>
                <span className="jayanagar-dental-clinic-star">★</span>
                <span className="jayanagar-dental-clinic-star">★</span>
                <span className="jayanagar-dental-clinic-reviews">
                  (105+)
                </span>
              </div>
            </div>
            <p className="jayanagar-dental-clinic-description">
              Family-friendly clinic with specialized pediatric dental
              care.
            </p>
            <div className="jayanagar-dental-clinic-features">
              <span className="jayanagar-dental-clinic-feature">
                <img
                  src="https://img.icons8.com/fluency/48/baby-smile.png"
                  alt="Child"
                />
                Kid-Friendly
              </span>
              <span className="jayanagar-dental-clinic-feature">
                <img
                  src="https://img.icons8.com/fluency/48/family.png"
                  alt="Family"
                />
                Family Care
              </span>
            </div>
            <div className="jayanagar-dental-clinic-cta">
              <span>View Details</span>
              <span className="jayanagar-dental-clinic-arrow">→</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

      {/* Footer */}
      {/* <DentalOffer /> */}
    </div>
  );
};

export default GirukambakkamDental;
